import React from 'react';
import { useNavigate } from 'react-router-dom';

export const PrivacyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        color: 'white',
        overflowY: 'auto'
      }}
    >
      <div
        style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '40px',
          borderRadius: '20px',
          backdropFilter: 'blur(20px)',
          maxWidth: '800px',
          width: '100%',
          textAlign: 'left',
          maxHeight: '80vh',
          overflowY: 'auto'
        }}
      >
        <button
          onClick={() => navigate('/')}
          style={{
            marginBottom: '20px',
            color: 'white',
            textDecoration: 'none',
            fontWeight: 600,
            background: 'rgba(255,255,255,0.2)',
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Home
        </button>

        <h1 style={{ fontSize: '32px', fontWeight: 700, marginBottom: '10px' }}>Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> January 24, 2026
        </p>
        <p style={{ marginTop: '16px', lineHeight: 1.6 }}>
          TheContactGame ("we", "our", or "the App") is a real-time multiplayer word game inspired by
          the classic Contact game. This Privacy Policy explains how we collect, use, and protect your
          information when you use the TheContactGame mobile application.
        </p>

        <hr style={{ margin: '20px 0', opacity: 0.3 }} />

        <h2 style={{ fontSize: '24px', marginTop: '24px', marginBottom: '12px' }}>
          1. Information We Collect
        </h2>
        <p style={{ marginBottom: '16px', lineHeight: 1.6 }}>
          We collect only minimal information required to operate the multiplayer game, including:
        </p>
        <ul style={{ margin: '0 0 16px 20px', lineHeight: 1.6 }}>
          <li>Anonymous device or user identifiers</li>
          <li>Game-related data such as room IDs, player actions, and game state</li>
          <li>
            Technical information such as IP address, connection logs, and diagnostics for performance
            and security
          </li>
        </ul>

        <h2 style={{ fontSize: '24px', marginTop: '24px', marginBottom: '12px' }}>
          2. How We Use Information
        </h2>
        <p style={{ marginBottom: '16px', lineHeight: 1.6 }}>
          We use the collected information only to enable and maintain real-time multiplayer gameplay,
          manage game sessions, and improve app performance.
        </p>

        <h2 style={{ fontSize: '24px', marginTop: '24px', marginBottom: '12px' }}>3. Data Sharing</h2>
        <p style={{ marginBottom: '16px', lineHeight: 1.6 }}>
          We do not sell, trade, or share your personal information with third parties.
        </p>

        <h2 style={{ fontSize: '24px', marginTop: '24px', marginBottom: '12px' }}>7. Contact Us</h2>
        <p style={{ marginBottom: '16px', lineHeight: 1.6 }}>
          If you have any questions about this Privacy Policy or our data practices, you can contact us
          at:
        </p>
        <p style={{ lineHeight: 1.6 }}>
          <strong>Email:</strong> support@thecontactgame.com
        </p>
      </div>
    </div>
  );
};
